<template>
  <section>
    <b-field>
      <b-upload v-model="droppedFile"
                @input="updateValue"
                :multiple="false"
                :drag-drop="true"
                :loading="isUploading"
                :disabled="isDisabled">
        <section class="section">
          <div class="content has-text-centered">
            <p>
              <b-icon
                pack="fas"
                icon="upload"
                size="is-large"/>
            </p>
            <p>こちらにファイルをドロップするか、クリックして選択してください</p>
          </div>
        </section>
      </b-upload>
    </b-field>

    <div class="tags">
      <span v-if="droppedFile" class="tag is-primary" style="font-size: 1rem;">
          {{ droppedFile.name }}
          <button class="delete is-small"
                  type="button"
                  @click="deleteDropFile">
          </button>
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FileUploadArea',
  model: {
    prop: 'droppedFile',
    event: 'change'
  },
  props: {
    droppedFile: File,
    isUploading: false,
    isDisabled: false
  },
  methods: {
    updateValue (selectedValue) {
      this.$emit('change', selectedValue)
    },
    deleteDropFile () {
      this.droppedFile = undefined
    }
  }
}
</script>


<style>
  .upload-draggable {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/inputs/FileUploadArea.vue